module.exports = __webpack_public_path__ + "img/QR.51a7338c.png";